import { useContext } from 'react';
//import { TranscriptCommentsRefPointContext } from '@/containers/Transcript.Commenting/Context';

export const SidebarContainer = () => {
  //const { ref } = useContext(TranscriptCommentsRefPointContext);
  return (<div>{null}</div>);
};